import { render } from "./FailIcon.vue?vue&type=template&id=434e4ad1"
import script from "./FailIcon.vue?vue&type=script&lang=js"
export * from "./FailIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__